import { Component } from '@theme/component';

class FaieGiftDesigns extends Component {
  static selected = new Map();
  static messages = new Map();

  connectedCallback() {
    super.connectedCallback();
    const value = FaieGiftDesigns.selected.get(this.dataset.productKey) || 'Signature';
    const input = Array.from(this.querySelectorAll('input[type="radio"]')).find(item => item.value === value);
    if (input) input.checked = true;
    this.updatePreview(value);
    this.restoreMessage();
  }

  updatedCallback() {
    super.updatedCallback();
    const value = FaieGiftDesigns.selected.get(this.dataset.productKey) || 'Signature';
    const input = Array.from(this.querySelectorAll('input[type="radio"]')).find(item => item.value === value);
    if (input) input.checked = true;
    this.updatePreview(value);
    this.restoreMessage();
  }

  selectDesign() {
    const input = this.querySelector('input:checked');
    if (!(input instanceof HTMLInputElement) || !input.checked) return;
    FaieGiftDesigns.selected.set(this.dataset.productKey, input.value);
    this.updatePreview(input.value);
  }

  restoreMessage() {
    const textarea = this.closest('form')?.querySelector('textarea[name="properties[Message]"]');
    if (!(textarea instanceof HTMLTextAreaElement)) return;
    textarea.value = FaieGiftDesigns.messages.get(this.dataset.productKey) || '';
    this.paintMessage(textarea.value);
  }

  updateMessage(event) {
    const textarea = event.target;
    if (!(textarea instanceof HTMLTextAreaElement)) return;
    const message = textarea.value.slice(0, 200);
    FaieGiftDesigns.messages.set(this.dataset.productKey, message);
    this.paintMessage(message);
  }

  paintMessage(message) {
    const section = this.closest('.shopify-section');
    if (!section) return;
    for (const caption of section.querySelectorAll('[data-gift-preview] [data-gift-caption]')) {
      caption.textContent = message.trim() || caption.dataset.defaultCaption;
      const art = caption.closest('.faie-gift-art');
      art?.classList.toggle('faie-gift-art--personalized', Boolean(message.trim()));
      art?.classList.toggle('faie-gift-art--long-message', message.length > 80);
    }
  }

  updatePreview(value) {
    const section = this.closest('.shopify-section');
    if (!section) return;
    for (const artwork of section.querySelectorAll('[data-card-design]')) {
      artwork.hidden = artwork.dataset.cardDesign !== value;
    }
  }
}

if (!customElements.get('faie-gift-designs')) customElements.define('faie-gift-designs', FaieGiftDesigns);
